import Grid from '@mui/material/Grid';
import { HeaderMobile } from './HeaderMobile';
import { navbarStyles } from './navbarStyles';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { HeaderDesktop } from './HeaderDesktop';

export const Navbar = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const classes = navbarStyles(theme, isDark);
  const isDownMd = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Grid
      container
      alignItems='center'
      justifyContent='space-between'
      direction='row'
      sx={classes.container}
      wrap='nowrap'
    >
      {isDownMd ? <HeaderMobile /> : <HeaderDesktop />}
    </Grid>
  );
};
